import * as pbm from '@/grpc-gen/event_type_pb';
import ApiEventType from '@/model/MessageEventType';

export default class EventType extends ApiEventType {
  static fromGrpcModel(o?: pbm.EventType): EventType {
    const eventType = new EventType();

    eventType.id = Number(o?.id ?? 0);
    eventType.type = o?.type ?? '';

    return eventType;
  }
}
